// Rota da tela de verificação (`spec/17-frontend.md` §8.1, WEB-07). A tela mora em
// `features/kyc/`; o arquivo de rota registra o caminho e liga a conexão em andamento do
// "Conectar com a Lezty Pay" (WEB-140): com pedido `bound` o wizard ganha o prefill e, com o
// KYC aprovado, a tela devolve o vendedor para `/oauth/authorize?resume=1`.

import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { currentRequestQueryOptions } from '../api/queries/oauth.ts';
import { CardSkeleton } from '../components/app/skeletons.tsx';
import { KycScreen } from '../features/kyc/wizard.tsx';

function KycRoute() {
  const navigate = useNavigate();
  // 404 (sem conexão em andamento) chega como `null`: o wizard abre como sempre.
  const connect = useQuery(currentRequestQueryOptions());
  const onContinue = useCallback(() => {
    void navigate({ to: '/oauth/authorize', search: { resume: true }, replace: true });
  }, [navigate]);

  if (connect.isPending) {
    return <CardSkeleton />;
  }
  return (
    <KycScreen
      {...(connect.data === null || connect.data === undefined
        ? {}
        : { connect: { request: connect.data, onContinue } })}
    />
  );
}

export const Route = createFileRoute('/app/settings/kyc/')({ component: KycRoute });
